import {
  DashboardPaymentMethod,
  DashboardTeamMembersValues,
  MerchantStats,
} from '../../__generated__/GQL';

export interface LineGraphData {
  newDate: string | null;
  oldDate: string | null;
  oldValue?: number | null;
  newValue: number | null;
}

export interface BarLineGraphData {
  date: string;
  earnings: number | null;
  spendings: number | null;
  monthStartBalance: number | null;
  // Hack for tooltip
  fullData?: {
    earnings: number | null;
    spendings: number | null;
    monthStartBalance: number | null;
  };
}

export enum DashboardFilter {
  'operationType',
  'clients',
  'merchant',
  'team',
}

export enum Quarter {
  FIRST = 'first',
  SECOND = 'second',
  THIRD = 'third',
  FOURTH = 'fourth',
}

export interface FiltersData {
  paymentMethod?: DashboardPaymentMethod;
  merchants?: MerchantStats[];
  teamMembers?: DashboardTeamMembersValues;
}
